<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div class="bg-white rounded-lg p-6 w-3/4 max-w-4xl">
      <h3 class="text-lg font-semibold mb-2">Medikamente</h3>
      <input v-model="search" type="text" placeholder="Suche..." class="w-full p-2 mb-4 border rounded">
      <div class="max-h-96 overflow-y-auto">
        <table class="w-full">
          <thead>
            <tr>
              <th class="text-left">Handelsname</th>
              <th class="text-left">Hersteller</th>
              <th class="text-left">PZN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="med in filteredMedications" :key="med.pzn" @click="$emit('select', med)" class="cursor-pointer hover:bg-gray-100">
              <td>{{ med.handelsname }}</td>
              <td>{{ med.hersteller }}</td>
              <td>{{ med.pzn }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <button @click="$emit('close')" class="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
        Schließen
      </button>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useDbStore } from '../../stores/dbStore';

export default {
  name: 'MedicationModal',
  emits: ['close', 'select'],
  setup() {
    const dbStore = useDbStore();
    const search = ref('');

    const filteredMedications = computed(() => {
      return dbStore.getMedications.filter(med => 
        med.handelsname.toLowerCase().includes(search.value.toLowerCase()) ||
        med.pzn.includes(search.value)
      );
    });

    return {
      search,
      filteredMedications
    };
  }
};
</script>